<template>
	<div class="row py-4">
		<div class="col-12 pt-4">
			<div class="container bg-light border border-light rounded p-2">
				<div class="form-row">
					<div class="col-12 col-sm-4 col-lg-2">
						<div class="form-group mb-1">
							<label for="rider">Rider weight</label>
							<div class="input-group" v-if="unit === 'metric'">
								<input-formatted placeholder="Rider " name="rider" v-model="inputs.rider.metric"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">kg</div>
								</div>
							</div>
							<div class="input-group" v-else>
								<input-formatted placeholder="Rider" name="rider" v-model="inputs.rider.us"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">lb</div>
								</div>
							</div>
						</div>	
					</div>
					<div class="col-12 col-sm-4 col-lg-2">
						<div class="form-group mb-1">
							<label for="gear">Gear weight</label>
							<div class="input-group" v-if="unit === 'metric'">
								<input-formatted placeholder="Gear" name="gear" v-model="inputs.gear.metric"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">kg</div>
								</div>
							</div>
							<div class="input-group" v-else>
								<input-formatted placeholder="Gear" name="gear" v-model="inputs.gear.us"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">lb</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-4 col-lg-2">
						<div class="form-group mb-1">
							<label for="luggage">Luggage weight</label>
							<div class="input-group" v-if="unit === 'metric'">
								<input-formatted placeholder="Luggage" name="luggage" v-model="inputs.luggage.metric"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">kg</div>
								</div>
							</div>
							<div class="input-group" v-else>
								<input-formatted placeholder="Luggage" name="luggage" v-model="inputs.luggage.us"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">lb</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-4 col-lg-2">
						<div class="form-group mb-1">
							<label for="farkles">Farkles weight</label>
							<div class="input-group" v-if="unit === 'metric'">
								<input-formatted placeholder="Farkles" name="farkles" v-model="inputs.farkles.metric"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">kg</div>
								</div>
							</div>
							<div class="input-group" v-else>
								<input-formatted placeholder="Farkles" name="farkles" v-model="inputs.farkles.us"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">lb</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-8 col-lg-4">
						<div class="form-group mb-1">
							<label for="target">Target range</label>
							<div class="input-group" v-if="unit === 'metric'">
								<input-formatted placeholder="Target" name="target" v-model="inputs.target.metric"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">km</div>
								</div>
							</div>

							<div class="input-group" v-else>
								<input-formatted placeholder="Target" name="target" v-model="inputs.target.us"></input-formatted>
								<div class="input-group-append">
									<div class="input-group-text">mi</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<loading :active.sync="isLoading" :is-full-page="false"></loading>
			<div id="chart">
				<apexchart type="scatter" height="350" :options="chartOptions" :series="series"></apexchart>
			</div>
		</div>
		<div class="col-12 pb-4">
			<div class="form-group my-2">
				<div class="container bg-light border border-light rounded p-2">
					<div class="row">
						<div class="form-group col-12 col-md-4">
							<div>
								<span id="labelvertical">Vertical:</span>
								<multiselect v-model="vertical" :options="yoptions" label="name" track-by="name" :custom-label="customLabel" :searchable="false" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Vertical" :preselect-first="false" aria-labelledby="labelVertical">
								</multiselect>
							</div>
						</div>
						<div class="form-group col-12 col-md-4">
							<div>
								<span id="labelhorizontal">Horizontal:</span>
								<multiselect placeholder="Horizontal" v-model="horizontal" :options="xoptions" label="name" track-by="name" :custom-label="customLabel" :searchable="false" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" :preselect-first="false" aria-labelledby="labelHorizontal"></multiselect>
							</div>
						</div>
						<div class="form-group col-12 col-md-4">
							<div>
								<span id="labelZaxis">Coloured by:</span>
								<multiselect v-model="groups" :options="groupOptions" label="name" track-by="name" :searchable="false" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Coloured by" :preselect-first="false" aria-labelledby="labelZaxis">
								</multiselect>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from "vue";

	import EventBus from '../eventbus';
	import Multiselect from "vue-multiselect";
	
	import VueApexCharts from "vue-apexcharts";
	Vue.use(VueApexCharts);

	import {mapGetters} from 'vuex';

	import Inputs from "./Inputs.vue";
	import Loading from "vue-loading-overlay";
	import "vue-loading-overlay/dist/vue-loading.css";


	export default {
		name: "Chartspage",
        components: {
        	'apexchart': VueApexCharts,
        	Multiselect,
        	Loading,
        	'input-formatted': Inputs,

        },
        mounted() {
        	let values = Object.keys(this.$route.query);
        	if(values.length === 0) {
        		return 
        	} else {
				this.horizontal =  this.xoptions.filter(item => item.id === this.$route.query.x)[0];
	        	this.vertical = this.yoptions.filter(item => item.id === this.$route.query.y)[0];
	        	this.groups = this.groupOptions.filter(item => item.id === this.$route.query.z)[0];
	        	delete this.$route.query.y
	        	delete this.$route.query.x
	        	delete this.$route.query.z

				this.$store.dispatch('BikeDataStore/getChartsRouterQuery', this.$route.query); 
        	}
        },
		data() {
			return {
				isLoading: false,
				chartOptions: {
					chart: {
						height: 350,
						type: 'scatter',
						zoom: {
							enabled: true,
							type: 'xy'
						}
					},
					xaxis: {
						forceNiceScale: true,
						tickAmount: 10,
						labels: {
							formatter: function(val) {
								return parseFloat(val).toFixed(0)
							}
						}
					},
					yaxis: {
						forceNiceScale: true,
						tickAmount: 7,
						labels: {
							formatter: function(val) {
								return parseFloat(val).toFixed(0)
							}
						}
					},

					legend: {
						show: true
					},
					tooltip: {
						enabled: true,
						custom: function({series, seriesIndex, dataPointIndex, w, z}) {
						    return `
							<div class="card">
								<div class="card-header font-weight-bold">
									${w.config.series[seriesIndex].data[dataPointIndex][2][0]}
								</div>
							</div>
							`
						},
						style: {
							fontSize: '12px',
							fontFamily: undefined
						},
						onDatasetHover: {
							highlightDataSeries: false,
						},
						x: {
							show: true,
							title: 'x title',
							formatter: (horizontal) => horizontal
						},
						y: {
							show: true,
							title: 'y title',
							formatter: (vertical) => vertical
						},
						z: {
							show: true,
							title: 'Bike: ',
							formatter: (zaxis) => zaxis
						},
						marker: {
							show: true,
						},
						items: {
							display: 'flex',
						},
						fixed: {
							enabled: false,
							position: 'topRight',
							offsetX: 0,
							offsetY: 0,
						},
					}
				},
				xoptions: [
					{ id: 'range', name: 'Factory Range', measurement: {us: 'mi', metric: 'km'}	},
					{ id: 'bikefuelcap', name: 'Fuel Tank Size', measurement : { us: 'gal', metric: 'L' } },
					{ id: 'bikefueleconcomb', name: 'Fuel Economy', measurement : { us: 'mpg', metric: 'L/100km' } },
					{ id: 'engdisp', name: 'Engine Displacement', measurement: { us: 'CI', metric: 'cc' } },
					{ id: 'engmaxpwr', name: 'Engine Max Power', measurement: { us: 'HP', metric: 'kW' } },
					{ id: 'startyr', name: 'First Production', measurement: { us: 'year', metric: 'year' } },
					{ id: 'engmaxpwrrpm', name: 'Max Power', measurement: { us: 'rpm', metric: 'rpm' } },
					{ id: 'engmaxtrq', name: 'Max Torque', measurement: { us: 'ft/lb', metric: 'nm' } },
					{ id: 'engmaxtrqrpm', name: 'Max Torque', measurement: { us: 'rpm', metric: 'rpm' } },
					{ id: 'engpwrdensity', name: 'Engine Power Density', measurement: { us: 'HP/CI', metric: 'W/cc' } },
					{ id: 'engsvcinterval', name: 'Oil Change Interval', measurement: { us: 'mi', metric: 'km' } },
					{ id: 'powertoweight', name: 'Power to Wet Weight', measurement: { us: 'HP/lb', metric: 'kW/kg' } },
					{ id: 'powertofullweight', name: 'Power to Full Weight', measurement: { us: 'HP/lb', metric: 'kW/kg'} },
					{ id: 'wheeltravelfrt', name: 'Front Travel', measurement: { us: 'in', metric: 'mm'} },
					{ id: 'wheeltravelrear', name: 'Rear Travel', measurement: { us: 'in', metric: 'mm' }},
					{ id: 'extrafuelrequired', name: 'Additional Fuel', measurement: { us: 'gal', metric: 'L' } },
					{ id: 'wetweightcalc', name: 'Weight (Wet)', measurement: { us: 'lb', metric: 'kg' } },
					{ id: 'fullbikeweight', name: 'Weight (Full)', measurement: { us: 'lb', metric: 'kg' } },
					{ id: 'fullbikeweightwrider', name: 'Weight (Full + Rider)', measurement: { us: 'lb', metric: 'kg' } }
				],
				yoptions: [
					{ id: 'range', name: 'Factory Range', measurement: {us: 'mi', metric: 'km'}	},
					{ id: 'bikefuelcap', name: 'Fuel Tank Size', measurement : { us: 'gal', metric: 'L' } },
					{ id: 'bikefueleconcomb', name: 'Fuel Economy', measurement : { us: 'mpg', metric: 'L/100km' } },
					{ id: 'engdisp', name: 'Engine Displacement', measurement: { us: 'CI', metric: 'cc' } },
					{ id: 'engmaxpwr', name: 'Engine Max Power', measurement: { us: 'HP', metric: 'kW' } },
					{ id: 'startyr', name: 'First Production', measurement: { us: 'year', metric: 'year' } },
					{ id: 'engmaxpwrrpm', name: 'Max Power', measurement: { us: 'rpm', metric: 'rpm' } },
					{ id: 'engmaxtrq', name: 'Max Torque', measurement: { us: 'ft/lb', metric: 'nm' } },
					{ id: 'engmaxtrqrpm', name: 'Max Torque', measurement: { us: 'rpm', metric: 'rpm' } },
					{ id: 'engpwrdensity', name: 'Engine Power Density', measurement: { us: 'HP/CI', metric: 'W/cc' } },
					{ id: 'engsvcinterval', name: 'Oil Change Interval', measurement: { us: 'mi', metric: 'km' } },
					{ id: 'powertoweight', name: 'Power to Wet Weight', measurement: { us: 'HP/lb', metric: 'kW/kg' } },
					{ id: 'powertofullweight', name: 'Power to Full Weight', measurement: { us: 'HP/lb', metric: 'kW/kg'} },
					{ id: 'wheeltravelfrt', name: 'Front Travel', measurement: { us: 'in', metric: 'mm'} },
					{ id: 'wheeltravelrear', name: 'Rear Travel', measurement: { us: 'in', metric: 'mm' }},
					{ id: 'extrafuelrequired', name: 'Additional Fuel', measurement: { us: 'gal', metric: 'L' } },
					{ id: 'wetweightcalc', name: 'Weight (Wet)', measurement: { us: 'lb', metric: 'kg' } },
					{ id: 'fullbikeweight', name: 'Weight (Full)', measurement: { us: 'lb', metric: 'kg' } },
					{ id: 'fullbikeweightwrider', name: 'Weight (Full + Rider)', measurement: { us: 'lb', metric: 'kg' } }
				],
				
				groupOptions: [
					{ id: 'make', name: 'Manufacturer' },
					{ id: 'engcylinders', name: 'Cylinder Qty' },
					{ id: 'engcooling', name: 'Cooling Type' },
					{ id: 'enggearqty', name: 'Gear Qty' },
					{ id: 'finaldrive', name: 'Final Drive' },
					{ id: 'engfueling', name: 'Fuel Delivery' },
					{ id: 'wheeldiafrt', name: 'Front Wheel Size' },
					{ id: 'wheeltype', name: 'Wheel Construction' }, 
					{ id: 'finaldrive', name: 'Final Drive' }, 
					{ id: 'bikeabs', name: 'ABS' }, 
				],
				horizontal:'',
				vertical: '',
				groups: '',
			}
		},
		methods: {
			getFilters(resultList, name) {
				let result = resultList.map(key => key[name].trim()).filter(Boolean).sort();
				return [...new Set(result)];
			},
			customLabel ({name, measurement}) {
	      		return `${name} (${measurement[this.unit]})`
	    	},
	    	sort(numbers) {
	    		return numbers.slice().sort(function(a, b) {
  					return a - b;
				});
	    	}
		},
		computed: {
			...mapGetters({
                data: 'BikeDataStore/getResults',
                inputs: 'BikeDataStore/getInputs',
                unit: 'BikeDataStore/getMeasurement'
            }),
			series() {
				const resultList = this.data;
				this.loading = true;
				if(!this.horizontal || !this.vertical || !this.groups) {
					this.loading = false;
					return [];
				} 
				const groups = this.getFilters(resultList, this.groups.id);
				
				// loop through the groups create obj and arr variables
				let master = [];
				// const yRange = resultList.map(bike => bike[this.vertical.id][this.unit] ? bike[this.vertical.id][this.unit] : parseFloat(bike[this.vertical.id])).slice().sort((a, b) => a - b);

				// this.chartOptions.yaxis.min = yRange[0];
				// this.chartOptions.yaxis.max = yRange[yRange.length - 1];
			
				for (let value of groups) {
					let arr = [];

					resultList.map(item => {
						if(item[this.groups.id] === value) {
							let xaxis = (typeof item[this.horizontal.id] == 'object') ? parseFloat(item[this.horizontal.id][this.unit]) : parseFloat(item[this.horizontal.id])
							let yaxis = (typeof item[this.vertical.id] == 'object') ? parseFloat(item[this.vertical.id][this.unit]) : parseFloat(item[this.vertical.id])

							arr.push([xaxis, yaxis, [`${item.make} ${item.model}`]])
						}
					})
					let obj = {};
					obj['name'] = value;
					obj['data'] = arr;
					master.push(obj);
				}
				this.loading = false;
				EventBus.$emit('urlValid');

				this.$store.dispatch('BikeDataStore/updateChartsUrl', {'x': this.horizontal.id, 'y': this.vertical.id, 'z': this.groups.id});

				return master
			}
		}
		
	}
</script>